import React, { useContext, useState } from "react";
import { useNotify } from "../components/NotificationComponent";
import { apiPost } from "../utils/api";
import { UserContext } from "../context/UserContext";
import { useNavigate } from "react-router-dom";

export default function DeleteAccountPage() {
  const [username, setUsername] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const { notify } = useNotify()
  const {setUserInfo} = useContext(UserContext)
  const navigate = useNavigate()
  
  const handleDeleteClick = (e) => {
    e.preventDefault();
    if (username.trim() === "") {
      notify("Please enter your username to proceed.");
      return;
    }
    setShowConfirm(true);
  };

  const confirmDelete = () => {
    apiPost('delete-account/').then(res =>{
        notify("Deleting account for user:", username);
        setShowConfirm(false);
        setUserInfo(undefined)
        localStorage.removeItem('userInfo')
    }).catch(err => {
        notify(err.response && err.response.data.detail ? err.response.data.detail : err.message)
    })
    // You can now trigger the actual API call here.
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold text-red-600 mb-4">Delete Your Account</h2>
        <p className="text-sm text-gray-600 mb-6">
          Please enter your username to proceed. This action is permanent and cannot be undone.
        </p>
        <form onSubmit={handleDeleteClick} className="space-y-4">
          <input
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
          />
          <button
            type="submit"
            className="w-full bg-red-600 text-white py-2 rounded-md hover:bg-red-700 transition"
          >
            Delete My Account
          </button>
          <p onClick={()=>navigate(-1)} className="text-center cursor-pointer font-semibold text-red-700">Cancel</p>
        </form>
      </div>

      {/* Confirmation Overlay */}
      {showConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-sm w-full text-center">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Are you sure?</h3>
            <p className="text-sm text-gray-600 mb-6">
              This action will permanently delete your account.
            </p>
            <div className="flex gap-4 justify-center">
              <button
                onClick={confirmDelete}
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
              >
                Yes, Delete
              </button>
              <button
                onClick={() => setShowConfirm(false)}
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
